import axios from 'axios';

const create = data => axios.post('/open/compradores', data);

export default {
  create,
};
